/* ============
 * Product Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';
import prodTrans from './product';

export default class WarehouseProductTransformer extends Transformer {

  static fetch(transaction) {
    return {
      id: transaction.id,
      warehouseId: transaction.warehouse_id,
      productId: transaction.product_id,
      batchName: transaction.batch_name,
      product: transaction.product !== undefined ? prodTrans.fetch(transaction.product) : [],
      qty: transaction.qty,
      qtyNumber: transaction.qty_number,
      minimumStockLevel: transaction.minimum_stock_level,
      name: transaction.name,
      supplierName: transaction.supplier_name,
    };
  }

  static send(transaction) {
    return {
      id: transaction.id,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/warehouseProduct.js